module.exports = __webpack_public_path__ + "static/media/map_europe-xs.966fad8b.png";